






import Vue from 'vue'
import * as types from '@/store/modules/play/types'

interface State {
  animationStart: number;
  currentTime: number;
  state: string;
}

export default Vue.extend({
  name: 'DebugAudioContext',

  data (): State {
    return {
      animationStart: 0,
      currentTime: 0,
      state: '',
    }
  },

  mounted () {
    window.requestAnimationFrame(this.displayCurrentTime)
  },

  computed: {
    /**
     * AudioContext
     */
    audioContext (): AudioContext | null {
      return this.$store.state[types.moduleName].audioContext
    },
  },

  methods: {
    /**
     * AudioContextの再生時間を表示
     * @param timestamp
     */
    displayCurrentTime (timestamp: number) {
      const progress = timestamp - this.animationStart  // 進捗

      if (this.audioContext) {
        this.currentTime = this.audioContext.currentTime
        this.state = this.audioContext.state
      }

      // requestAnimationFrameは間引く（スマホで実行すると端末がかなり熱くなる）
      if (progress > 41.6) {
        // 繰り返し
        window.requestAnimationFrame(this.displayCurrentTime)
      }
    },
  },

  filters: {
    /**
     * 秒→hh:mm:ss.ss
     * @param sec 秒
     */
    secToTime (sec: number) {
      return sec
    },
  },
})
